export const enum LiveDataEventTypes {
    // The values used here are (and have to be) identical to the names which are used in the backend, do not change these.
    EVENTS = 'events',
    NOTIFICATIONS = 'notifications',
    GCP_TELEMETRIES = 'gcp-telemetries',
    DHW_TELEMETRIES = 'dhw-telemetries',
    GATEWAY_STATUSES = 'gateway-statuses',
    WALLBOX_TELEMETRIES = 'wallbox-telemetries',
    ELECTRIC_CAR_TELEMETRIES = 'electric-car-telemetries',
    PVBATTERY_TELEMETRIES = 'pvbattery-telemetries',
    COMPRESSOR_TELEMETRIES = 'compressor-telemetries',
    HEAT_PUMP_TELEMETRIES = 'heatpump-telemetries',
}

export const enum LiveDataActionTypes {
    UNUSABLE_EVENT = 'UNUSABLE_EVENT',
    GCP_TELEMETRIES = 'GCP_TELEMETRIES',
    EMOBILITY_STATUS = 'EMOBILITY_STATUS',
    GATEWAY_STATUSES = 'GATEWAY_STATUSES',
    EVENT_NOTIFICATION = 'EVENT_NOTIFICATION',
    PVBATTERY_TELEMETRIES = 'PVBATTERY_TELEMETRIES',
    WALLBOX_TELEMETRIES = 'WALLBOX_TELEMETRIES',
    ELECTRIC_CAR_TELEMETRIES = 'ELECTRIC_CAR_TELEMETRIES',
    UPDATE_ELECTRIC_CAR_TELEMETRIES = 'UPDATE_ELECTRIC_CAR_TELEMETRIES',
    HEAT_PUMP_TELEMETRIES = 'HEAT_PUMP_TELEMETRIES',
    SET_GRIDX_INTERVENTIONS = 'SET_GRIDX_INTERVENTIONS',
    /** Fired when the BE sends ElectricCar-Event / ev-link-complete via WebSocket (V3 async linking flow) */
    ELECTRIC_CAR_LINKED = 'ELECTRIC_CAR_LINKED',
}

export const enum TelemetryTypes {
    GCP = 'gcp',
    DHW = 'dhw',
    WALLBOX = 'wallbox',
    ELECTRIC_CAR = 'electricCar',
    PV_BATTERY = 'pvbattery',
    COMPRESSOR = 'compressor',
    NOTIFICATIONS = 'notifications',
    GATEWAY_STATUSES = 'gatewayStatuses',
    EMOBILITY = 'emobility',
    HEAT_PUMP = 'heatpump',
}

export enum FirmwareOngoingUpdateStatuses {
    FIRMWARE_UPDATE_ACCEPTED = 'FIRMWARE_UPDATE_ACCEPTED',
    REBOOT_ACCEPTED = 'REBOOT_ACCEPTED',
    REBOOT_COMPLETED = 'REBOOT_COMPLETED',
    UPDATE_DOWNLOAD_STARTED = 'UPDATE_DOWNLOAD_STARTED',
    FIRMWARE_UPDATE_DOWNLOADED = 'FIRMWARE_UPDATE_DOWNLOADED',
    FIRMWARE_UPDATE_INSTALLED = 'FIRMWARE_UPDATE_INSTALLED',
    FINISHED_FAILED = 'FINISHED_FAILED',
    FINISHED_SUCCESS = 'FINISHED_SUCCESS',
}

export enum MessageTypeEnumExtended {
    ELECTRIC_CAR_EVENT = 'ElectricCar-Event',
    EVSE_FIRMWARE = 'Evse-Firmware',
    EVSE_SECURITY_NOTIFICATION = 'Evse-Security-Notification',
}

export enum WebsocketMessageSubTypeEnum {
    ENODE_ACTION = 'enode-action',
    GRIDX_ACTION = 'gridx-action',
    EV_LINK_COMPLETE = 'ev-link-complete',
    HEAT_PUMP_STATE_CHANGE = 'heat_pump_state_change',
    TIME_OF_USE_BATTERY_DECISION = 'tou_decision:battery',
}

export enum ElectricCarEventReason {
    CatchPlugAndCharge = 'CATCH_PLUG_AND_CHARGE',
}
